/**
 * Adapt a list of a resource with the given adapter callback.
 *
 * @param { array } list List to adapt
 * @param { function } callback Callback used to adapt each item of the list
 * @returns List of adapted items
 */
export var multiple = async (list, callback) => {
  // Here, we are assuming all callbacks return a promise
  const promises = list.map(item => callback(item));
  return Promise.all(promises);
};
